import classnames from 'classnames';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { isLoading } from '../../../stores/navigation/selectors';
import { RootState } from '../../../stores/store';
import { LoadingButton } from '../../navigation/LoadingButton';
import './ConfirmModal.scss';

interface Props extends LocalizeContextProps {
    buttonColor?: string;
    header: string;
    confirmText: string;
    isOpen: boolean;
    isLoading: boolean;
    children?: React.ReactNode;
    bodyHeight?: string;
    className?: string;
    big?: boolean;

    confirm: () => void;
    cancel: () => void;
}

class ConfirmModal extends React.Component<Props> {
    public componentDidUpdate(prevProps: Props) {
        if (this.props.isOpen === true && prevProps.isOpen === false) {
            if (/Trident.*rv:/.test(navigator.userAgent)) {
                setTimeout(
                    () => {
                        const modal = document.getElementById('confirm-modal')!
                            .parentElement!.parentElement!.parentElement;
                        if (modal) {
                            modal.style.display = 'none';
                            modal.style.display = '';
                            modal.style.zIndex = '';
                        }
                    },
                    500);
            }
        }
    }

    public render() {
        const t = this.props.translate;
        return (
            <Modal
                id="confirm-modal"
                isOpen={this.props.isOpen}
                toggle={this.props.cancel}
                className={classnames(this.props.big ? 'big' : '', this.props.className)}
            >
                <ModalHeader toggle={this.props.cancel}>
                    {this.props.header}
                </ModalHeader>
                <ModalBody style={{ height: this.props.bodyHeight ?? 'auto' }} >
                    {this.props.children}
                </ModalBody>
                <ModalFooter>
                    <LoadingButton
                        color={this.props.buttonColor ?? 'primary'}
                        onClick={() => {
                            this.props.confirm();
                            this.props.cancel();
                        }}
                        loading={this.props.isLoading}
                    >
                        {this.props.confirmText}
                    </LoadingButton>
                    <Button color="secondary" onClick={this.props.cancel}>{t('modal.cancel')}</Button>
                </ModalFooter>
            </Modal>
        );
    }
}

const mapStateToProps = (state: RootState) => ({

    isLoading: isLoading(state),
});

export default connect(mapStateToProps)(withLocalize(ConfirmModal));